/**
 * @file Allow using app feature flags
 */
import window from 'bits/global'

type CurrentFlags =
  | 'wishOrderArray'
  | 'debugFrontend'
  | 'goldPlansVisible'
  | 'contentPicker'
  | 'newPostEditModal'
  | 'brahmsRealtime'
  | 'inviteLink'
  | 'newTweetPreview'
  | 'newSurfaceShadows'
  | 'pressCToPost'
  | 'expandedPostV1'

function isAppUsing(feature: CurrentFlags, version?: null | number): boolean {
  const ww = window.ww || {}
  const flip = ww.flip || {}
  if (version) {
    return flip[feature] >= version
  }
  return flip[feature] || false
}

export { isAppUsing }
